import styled from 'styled-components';
import { motion } from 'framer-motion';
import { colors } from '@keen.io/colors';
import { UI_LAYERS } from '@keen.io/ui-core';
export var TitleWrapper = styled.div.withConfig({
  displayName: "Extractionstyles__TitleWrapper",
  componentId: "keen-query-creator__sc-13xe1r4-0"
})(["&&&{display:flex;align-items:center;}"]);
export var LimitInput = styled.div.withConfig({
  displayName: "Extractionstyles__LimitInput",
  componentId: "keen-query-creator__sc-13xe1r4-1"
})(["&&&{position:relative;max-width:100px;}"]);
export var TooltipMotion = styled(motion.div).withConfig({
  displayName: "Extractionstyles__TooltipMotion",
  componentId: "keen-query-creator__sc-13xe1r4-2"
})(["&&&{position:absolute;left:0%;top:100%;width:320px;z-index:", ";}"], UI_LAYERS.tooltip);
export var TooltipContainer = styled.div.withConfig({
  displayName: "Extractionstyles__TooltipContainer",
  componentId: "keen-query-creator__sc-13xe1r4-3"
})(["&&&{display:inline-block;margin-left:10px;position:relative;cursor:pointer;}"]);
export var Container = styled.div.withConfig({
  displayName: "Extractionstyles__Container",
  componentId: "keen-query-creator__sc-13xe1r4-4"
})(["&&&{padding-top:15px;border-top:1px solid ", ";display:flex;flex-direction:column;row-gap:15px;}"], colors.gray[300]);
export var TooltipWrapper = styled(motion.div).withConfig({
  displayName: "Extractionstyles__TooltipWrapper",
  componentId: "keen-query-creator__sc-13xe1r4-5"
})(["&&&{width:160px;position:absolute;top:45px;z-index:1;}"]);